/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ResponseApi,
  ResponseApiDengLuYanZhengMa,
  ResponseApiDengLuYongHuXinXi,
  ResponseApiObject,
  ResponseApiUserDetails,
  YongHuDengLu,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class XiTongXiTongShouQuanJieKou<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags XiTongXiTongShouQuanJieKou
   * @name GetCodeUsingGet
   * @summary 获取验证码
   * @request GET:/dsp-admin/api/sys/auth/code
   * @secure
   */
  getCodeUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApiDengLuYanZhengMa, void>({
      path: `/dsp-admin/api/sys/auth/code`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description 系统框架默认数据格式
   *
   * @tags XiTongXiTongShouQuanJieKou
   * @name GetUserInfoUsingGet
   * @summary 获取用户信息
   * @request GET:/dsp-admin/api/sys/auth/info
   * @secure
   */
  getUserInfoUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApiUserDetails, void>({
      path: `/dsp-admin/api/sys/auth/info`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongXiTongShouQuanJieKou
   * @name LoginUsingPost1
   * @summary 密码登录授权
   * @request POST:/dsp-admin/api/sys/auth/login
   * @secure
   */
  loginUsingPost1 = (authUser: YongHuDengLu, params: RequestParams = {}) =>
    this.request<ResponseApiDengLuYongHuXinXi, void>({
      path: `/dsp-admin/api/sys/auth/login`,
      method: "POST",
      body: authUser,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongXiTongShouQuanJieKou
   * @name LogoutUsingDelete
   * @summary 退出登录
   * @request DELETE:/dsp-admin/api/sys/auth/logout
   * @secure
   */
  logoutUsingDelete = (params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/auth/logout`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description 按照前端要求格式返回数据
   *
   * @tags XiTongXiTongShouQuanJieKou
   * @name GetUserInfoV2UsingGet
   * @summary 获取用户信息(新)
   * @request GET:/dsp-admin/api/sys/auth/userInfo
   * @secure
   */
  getUserInfoV2UsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApiObject, void>({
      path: `/dsp-admin/api/sys/auth/userInfo`,
      method: "GET",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new XiTongXiTongShouQuanJieKou();
